import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { materialIconsAppInitializerFactory } from './core/material-icons-app-initializer.factory';
import { languageAppInitializerFactory } from './core/language-app-initializer.factory';
import { createTranslateLoader } from './core/translate-loader.factory';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SharedModule } from './shared/shared.module';
import { LandingModule } from './landing/landing.module';
import { HttpService } from './services/http-service.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { acceptLanguageInterceptor } from './core/accept-language.interceptor';
import { LanguageService } from './services/language.service';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { MatDialogModule } from '@angular/material/dialog';
import { provideEnvironmentNgxCurrency } from 'ngx-currency';
import { InputMaskModule } from '@ngneat/input-mask';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    // Service worker desactivado temporalmente. Para reactivarlo:
    // volver a importar `isDevMode` desde '@angular/core' y usar `enabled: !isDevMode()`.
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    LandingModule,
    SharedModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    MatDialogModule,
    InputMaskModule,
    TranslateModule.forRoot({
      fallbackLang: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
      },
    }),
  ],
  providers: [
    provideHttpClient(withInterceptors([acceptLanguageInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: materialIconsAppInitializerFactory,
      deps: [MatIconRegistry, DomSanitizer],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: languageAppInitializerFactory,
      deps: [LanguageService],
      multi: true,
    },
    HttpService,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    provideEnvironmentNgxCurrency({
      prefix: '$ ',
      thousands: ',',
      decimal: '.',
      min: 0,
      nullable: false,
      align: 'left',
      allowNegative: false,
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
